export default __webpack_public_path__ + "static/media/8.6ed96750.png";